import { PoolbettingError } from './PoolbettingError.js';

/**
 * Error instance representing when an entity isn't found, eg. draw. Synonym to HTTP 404
 */
export class NotFoundError extends PoolbettingError {
  constructor(message = 'Resource not found', options?: ErrorOptions) {
    super(message, options, 'NOT_FOUND');
    this.name = 'NotFoundError';
  }
}
